import { importProvidersFrom } from '@angular/core';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';

export const STORAGE_CONFIG = [
  importProvidersFrom(
    IonicStorageModule.forRoot({
      name: 'piled_db',
      driverOrder: [
        Drivers.IndexedDB,    // Default for browser
        Drivers.LocalStorage, // Fallback for browser
        Drivers.SecureStorage // For native iOS/Android when available
      ]
    })
  )
]; 